<template>
  <section class="pagos">
    <DsChip label="Tus pagos" variant="orange" />

    <div class="pagos__hero">
      <div class="pagos__heading">
        <DsTextSplit
            as="h4"
            base="Mantente al día y"
            highlight="protege tu avance"
            baseColor="var(--ds-purple-900)"
            highlightColor="#6D59EA"
          />
        <DsText as="h3" color="var(--ds-secondary-main)"></DsText>
        <DsText as="h3" color="var(--ds-purple-main)"></DsText>
      </div>

      <div class="pagos__notice">
        <span class="pagos__notice-icon">
          <img :src="calendarIcon" alt="" aria-hidden="true">
        </span>
        <DsText as="body3" class="pagos__notice-copy">
          <span class="pagos__notice-line">Sigue avanzando en tu financiamiento. Realiza tu pago puntual &nbsp;</span>
          <strong class="pagos__notice-highlight">cada día 1 del mes.</strong>
        </DsText>
      </div>
    </div>

    <div class="pagos__divider" aria-hidden="true" />

    <div class="pagos__why">
      <DsText as="subtitle14" color="var(--ds-text-primary)">Es importante porque:</DsText>

      <div class="pagos__chips">
        <article v-for="item in items" :key="item" class="pagos__chip">
          <span class="pagos__chip-icon">
            <img src="../../../assets/bienvenida_icon_check.svg" alt="" aria-hidden="true" class="pagos__chip-icon-img" />
          </span>
          <DsText as="body4" class="pagos__chip-copy">{{ item }}</DsText>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import DsChip from '../atoms/DsChip.vue'
import DsText from '../atoms/DsText.vue'
import DsTextSplit from '../atoms/DsTextSplit.vue'
import calendarIcon from '../../../assets/bienvenida-mobile/icon-calendario.svg'

const items = [
  'Mantienes tus beneficios',
  'Evitas cargos adicionales',
  'No afectas tu permanencia en el sistema',
]
</script>

<style scoped>
.pagos {
  display: grid;
  gap: 24px;
  align-items: stretch;
}

.pagos__hero {
  display: grid;
  gap: 28px;
  align-items: center;
}

.pagos__heading {
  display: flex;
  flex-direction: column;
  gap: 0;
}

pagos__chip{
  padding-top: 1rem;
}

.pagos__notice {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(47, 45, 116, 0.18);
  border-radius: 8px;
  padding: 16px;
}

.pagos__notice-icon {
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagos__notice-icon img { display: block; width: 40px; height: 40px; object-fit: contain; }

.pagos__notice-copy {
  color: var(--ds-text-primary);
  line-height: 1.25;
}

.pagos__notice-line {
  display: inline;
}

.pagos__notice-highlight {
  color: #1F1460;
}

.pagos__divider {
  height: 1px;
  background: rgba(47, 45, 116, 0.22);
}

.pagos__why {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.pagos__chips {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.pagos__chip {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 60px;
  border-radius: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
}

.pagos__chip-icon {
  width: 24px;
  height: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagos__chip-icon-img {
  width: 21px;
  height: 16px;
  display: block;
}

.pagos__chip-copy {
  color: var(--ds-text-primary);
  line-height: 1.2;
}

@media (max-width: 1024px) {
  .pagos {
    grid-template-columns: 1fr;
    width: 100%;
    justify-self: center;
    align-self: center;
    background: #ffffff;
    border-radius: 16px;
    gap: 32px;
  }

  .pagos__notice-line {
    display: block;
  }
}

@media (min-width: 1025px) {
  .pagos__hero { gap: 24px; }
  .pagos__notice { min-height: 72px; box-sizing: border-box; }
  .pagos__notice-copy { line-height: 24px; }
  .pagos__divider { display: none; }
  .pagos__why { gap: 16px; }
  .pagos__chips { gap: 16px; }
  .pagos__chip { min-height: 56px; padding: 8px; }
  .pagos__chip-copy { line-height: 24px; }
}

@media (max-width: 768px) {
  .pagos {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-self: center;
  }

  .pagos__hero {
    grid-template-columns: 1fr;
  }

  .pagos__chips {
    grid-template-columns: 1fr;
  }

  .pagos__divider { display: none; }
}
</style>
